<template>
  <tr>
    <td class="align-middle">
      <div>
        <small>
          {{ dayMonth(search.created_at) }}

          <small class="text-muted">
            {{ minuteHour(search.created_at) }}
          </small>
        </small>
      </div>
    </td>
    <td class="align-middle">
      <small>
        {{ contractTypeName }}
      </small>
    </td>
    <td class="align-middle">
      <small>
        {{ search.postal_code }}
      </small>
    </td>
    <td class="align-middle">
      <small>
        {{ search.power_consumption }}kWh
      </small>
    </td>
    <td class="align-middle">
      <small>
        {{ search.ip_address }}
      </small>
    </td>
  </tr>
</template>

<script>

  import DateMixin from "../../../../app/mixins/helpers/DateMixin"
  import {contractTypes} from "../../../../app/services/data/contractTypes"

  export default {
    name: "SearchItem",
    mixins: [
      DateMixin
    ],
    props: {
      search: Object
    },
    computed: {
      contractTypeName(){
        const type = contractTypes.find(type => type.handle === this.search.contract_type)

        if(type !== undefined){
          return type.name
        }

        return null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Searches/Partials/SearchItem.vue